// extracted by mini-css-extract-plugin
export default {"container":"sticky-bar_container__e89tn"};